"use strict";
/**
 * Types for registration form field configs (standard + event-sourced).
 * When eventSource is set, options are resolved at runtime from the event.
 */
Object.defineProperty(exports, "__esModule", { value: true });
